import React from 'react'
import Layout from '../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SofastBV3Viscometer = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        '/img/instruments/Sofast BV3 Viscometer.jpeg',
        '/img/instruments/Sofast BV3 Viscometer.jpeg'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/">R & D</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Sofast BV3 Viscometer </h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Sofast BV3 Viscometer </h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Sofast BV3benchtop viscometer using the vibrating technology at resonance frequency. The most complete solution for a fast & reliable viscosity measurement in laboratory conditions. Using a beaker or a 2ml sample tube, the Sofast BV is the most efficient instrument for fast viscosity measurement. it allows quick measurement acquisition and fast cleaning. The complete measuring cycle performed in less than sixty seconds, and ready for the next sample. <br />
                                    <strong>Measuring Range: Full Scale Range: [0.1 – 100] cP/ [1 – 1 000] cP</strong>
                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Fiber Potential Online (FPO)"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section> 
            <br />
        </Layout>
    )
}

export default SofastBV3Viscometer